
import React from 'react';
import { Helmet } from 'react-helmet';
import { ShortContentItem } from '@/hooks/useShortContent';

interface TravelByteOpenGraphProps {
  item: ShortContentItem;
  baseUrl: string;
}

export function TravelByteOpenGraph({ item, baseUrl }: TravelByteOpenGraphProps) {
  const title = item.title;
  const description = item.content.substring(0, 160).replace(/<[^>]*>/g, ''); // Strip HTML tags
  const imageUrl = item.image_url || `${baseUrl}/og-image.png`;
  const url = `${baseUrl}/travel-bytes/${item.slug}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title} | Travel Bytes</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={`travel, ${item.content_type}, ${item.category || ''}, travel tips, travel facts`} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="article" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Trotting the World" />
      <meta property="article:published_time" content={item.publish_date ? new Date(item.publish_date).toISOString() : new Date(item.created_at).toISOString()} />
      <meta property="article:section" content={item.category || "Travel"} />
      <meta property="article:tag" content={item.content_type} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:creator" content="@trottingtheworld" />
    </Helmet>
  );
}
